import jwtDecode from "jwt-decode"

export const getAuthUserToken = () => {
  const tokenString = localStorage.getItem("authStudentUser");
  return tokenString ? JSON.parse(tokenString) as string : null;
}

function decodeToken(token: string) {
  try {
    const decoded = jwtDecode<Record<string, any>>(token);
    return decoded;
  } catch (error) {
    return null;
  }
}


export const getAuthUserInfo = () => {
    const token  = getAuthUserToken();
    if(!token)
      return null;

    const claims = decodeToken(token);
    if(!claims)
      return null;

    return {
      userId: claims.sa_login_id as string,
      name: `${claims.st_first_name} ${claims.st_surname}`,
      student_key: claims.pk_student_key,
      pk_cent_key: claims.pk_cent_key,
    }
}